<template>
  <div class="px-10">
    <v-row>
      <v-col>
        <span class="font-16 font-calibri font-weight-bold">Income Tax</span>
        <employee-profile-payroll-income-tax-detail-dialog-edit
          v-if="$hasPermissionTo(['update employee payroll']) && !isResigned"
          :income-tax-detail="incomeTaxDetail"
          :employee-uid="employeeUid"
          @updated="loadEmployeeIncomeTax"
        />
      </v-col>
    </v-row>

    <v-row class="mx-0">
      <v-col class="pa-0">
        <span class="font-weight-medium">Member Number:</span>
        <v-progress-circular
          v-if="loading"
          indeterminate
          size="20"
          width="3"
          color="primary"
          class="ml-3"
        />
        <span
          v-else
          class="pl-3"
        >
          {{ (incomeTaxDetail||{}).income_tax_number ||'N/A' }}
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollIncomeTaxDetailDialogEdit: () => import('@/components/hris/employee/profile/payroll/income-tax-detail/DialogEdit'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        incomeTaxDetail: {},
      }
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.loadEmployeeIncomeTax()
          }
        },
      },
    },
  
    methods: {
      loadEmployeeIncomeTax () {
        this.loading = true

        this.$api.employeePayrollIncomeTax().list(this.employeeUid)
          .then(res => {
            this.incomeTaxDetail = res.data

            this.loading = false
          })
      },
    },
  }
</script>

<style scoped>
.font-calibri{
  font-family: Calibri !important;
}

.font-16{
  font-size:16px;
}
</style>
